<template>
  <v-fab-transition>
    <v-speed-dial
      v-show="actionsToShow.length"
      v-model="isOpen"
      direction="top"
      transition="slide-y-reverse-transition"
      fixed
      bottom
      right
    >
      <template #activator>
        <v-btn v-model="isOpen" color="primary" dark fab>
          <v-icon>{{ isOpen ? 'close' : 'apps' }}</v-icon>
        </v-btn>
      </template>
      <v-tooltip v-for="action in actionsToShow" :key="action.icon" left>
        <template #activator="{ on }">
          <v-btn :color="action.color" dark fab small v-on="on" @click="onClick(action.key)">
            <v-icon>{{ action.icon }}</v-icon>
          </v-btn>
        </template>
        <span>{{ action.name }}</span>
      </v-tooltip>
    </v-speed-dial>
  </v-fab-transition>
</template>

<script>
export default {
  name: 'FabActions',
  props: {
    canDelete: {
      type: Boolean,
      default: true,
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
    canImport: {
      type: Boolean,
      default: true,
    },
    canExport: {
      type: Boolean,
      default: true,
    },
    canCreate: {
      type: Boolean,
      default: true,
    },
    canRenew: {
      type: Boolean,
      default: true,
    },
    context: {
      type: String,
      default: undefined,
    },
    hasChanges: {
      type: Boolean,
      default: false,
    },
    isPublished: {
      type: Boolean,
      default: false,
    },
    isArchived: {
      type: Boolean,
      default: false,
    },
    alwaysSave: {
      type: Boolean,
      default: false,
    },
    labels: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    isOpen: false,
  }),
  computed: {
    actionsToShow() {
      return [
        {
          key: 'create',
          icon: 'add',
          name: this.labels.create || this.appendContext('Create'),
          color: 'green',
          show: true,
        },
        {
          key: 'delete',
          icon: 'delete',
          name: this.labels.delete || this.appendContext('Delete'),
          color: 'red',
          show: this.canDelete && !this.isArchived,
        },
        {
          key: 'reset',
          icon: 'autorenew',
          name: this.labels.reset || 'Reset Changes',
          color: 'blue',
          show: this.hasChanges && this.canEdit,
        },
        {
          key: 'save',
          icon: 'save',
          name: this.labels.save || this.appendContext('Save'),
          color: 'green',
          show: (this.hasChanges || this.alwaysSave) && this.canEdit,
        },
        {
          key: 'publish',
          icon: 'publish',
          name: this.labels.publish || this.appendContext('Save & Publish'),
          color: 'cyan',
          show: !this.isPublished && this.canEdit,
        },
        {
          key: 'draft',
          icon: 'drafts',
          name: this.labels.draft || this.appendContext('Save & Draft'),
          color: 'orange',
          show: this.isPublished && this.canEdit,
        },
        {
          key: 'preview',
          icon: 'visibility',
          name: this.labels.preview || this.appendContext('Preview'),
          color: 'orange',
          show: true,
        },
        {
          key: 'import',
          icon: 'upload',
          name: this.labels.import || this.appendContext('Import'),
          color: 'grey darken-1',
          show: this.canCreate,
        },
        {
          key: 'export',
          icon: 'download',
          name: this.labels.export || this.appendContext('Export'),
          color: 'grey darken-1',
          show: true,
        },
        {
          key: 'renew',
          icon: 'auto_fix_high',
          name: this.labels.renew || this.appendContext('Renew'),
          color: 'purple',
          show: this.canRenew,
        },
        {
          key: 'help',
          icon: 'help',
          name: 'Help',
          color: 'grey',
          show: true,
        },
      ].filter(({ key, show }) => this.actionsFromListeners.includes(key) && show)
    },
    actionsFromListeners() {
      return Object.keys(this.$listeners)
    },
  },
  watch: {
    hasChanges(val) {
      setTimeout(() => {
        if (!val) return
        this.isOpen = true
      }, 100)
    },
  },
  methods: {
    appendContext(string) {
      return [string, this.context].filter(Boolean).join(' ')
    },
    onClick(type) {
      this.$emit(type)
    },
  },
}
</script>
